"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudToDevice = exports.DeviceToCloud = exports.C2DMessage = exports.D2CMessage = exports.PrefsC2DMessage = exports.PrefsD2CMessage = exports.ConsumableC2DMessage = exports.ConsumableD2CMessage = exports.TelemetryC2DMessage = exports.TelemetryMessage = exports.CommandC2DMessage = exports.StateC2DMessage = exports.StateMessage = exports.EventMessage = exports.AlarmD2CMessage = exports.AlarmD2CPayload = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const date_1 = require("../../../../date");
const hydrotap_bridge_1 = require("../../../device/class/hydrotap-bridge");
const common_1 = require("../../common");
const Common = __importStar(require("../../common"));
const hydrotap_bridge_2 = require("../../common/device/hydrotap-bridge");
const Command = __importStar(require("../command"));
const Consumable = __importStar(require("../consumable"));
const Event = __importStar(require("../event"));
const message_1 = require("../message");
const Prefs = __importStar(require("../prefs"));
const State = __importStar(require("../state"));
const Telemetry = __importStar(require("../telemetry"));
exports.NAMESPACE = 'Culligan.Protocol.V2.Device.HydroTapBridge';
exports.AlarmD2CPayload = effect_1.Schema.Union(effect_1.Schema.Struct({
    action: effect_1.Schema.optionalWith(effect_1.Schema.Union(Common.Alarm.RaiseFromLowercase, Common.Alarm.DismissFromLowercase, Common.Alarm.DismissAnyFromLowercase), {
        exact: true,
        default: () => 'Raise',
    }),
    alarmCode: hydrotap_bridge_2.AlarmFromAlarmCode,
    time: date_1.Timestamp,
}).pipe(effect_1.Schema.rename({ action: '_tag', alarmCode: 'alarm' })), effect_1.Schema.Struct({
    action: Common.Alarm.DismissAllFromLowercase,
    time: date_1.Timestamp,
}).pipe(effect_1.Schema.rename({ action: '_tag' }))).annotations({ identifier: `${exports.NAMESPACE}.AlarmD2CPayload` });
exports.AlarmD2CMessage = (0, message_1.createMessage)('alarm', exports.AlarmD2CPayload).annotations({
    identifier: `${exports.NAMESPACE}.AlarmD2CMessage`,
    title: 'Alarm Message',
});
exports.EventMessage = Event.createD2CMessage(exports.NAMESPACE, hydrotap_bridge_1.HydroTapBridge.events).annotations({
    identifier: `${exports.NAMESPACE}.EventMessage`,
});
exports.StateMessage = State.createD2CMessage(hydrotap_bridge_1.HydroTapBridge.State).annotations({
    identifier: `${exports.NAMESPACE}.StateMessage`,
});
exports.StateC2DMessage = State.createC2DMessage(hydrotap_bridge_1.HydroTapBridge.State).annotations({
    identifier: `${exports.NAMESPACE}.StateC2DMessage`,
});
exports.CommandC2DMessage = Command.createD2CMessage(exports.NAMESPACE, hydrotap_bridge_1.HydroTapBridge.commands).annotations({
    identifier: `${exports.NAMESPACE}.CommandC2DMessage`,
    title: 'Command Message',
});
exports.TelemetryMessage = Telemetry.createD2CMessage(hydrotap_bridge_1.HydroTapBridge.Telemetry).annotations({
    identifier: `${exports.NAMESPACE}.TelemetryMessage`,
});
exports.TelemetryC2DMessage = Telemetry.C2DMessage.annotations({
    identifier: `${exports.NAMESPACE}.TelemetryC2DMessage`,
});
exports.ConsumableD2CMessage = Consumable.createD2CMessage(exports.NAMESPACE, hydrotap_bridge_1.HydroTapBridge.slots);
exports.ConsumableC2DMessage = Consumable.createC2DMessage(exports.NAMESPACE, hydrotap_bridge_1.HydroTapBridge.slots, hydrotap_bridge_1.HydroTapBridge.Catalogue);
exports.PrefsD2CMessage = Prefs.createD2CMessage(exports.NAMESPACE, hydrotap_bridge_1.HydroTapBridge.Prefs);
exports.PrefsC2DMessage = Prefs.createC2DMessage(exports.NAMESPACE, hydrotap_bridge_1.HydroTapBridge.Prefs);
exports.D2CMessage = effect_1.Schema.Union(exports.AlarmD2CMessage, exports.ConsumableD2CMessage, exports.EventMessage, exports.StateMessage, exports.TelemetryMessage, exports.PrefsD2CMessage).annotations({
    identifier: `${exports.NAMESPACE}.D2CMessage`,
});
exports.C2DMessage = effect_1.Schema.Union(exports.ConsumableC2DMessage, exports.StateC2DMessage, exports.CommandC2DMessage, exports.TelemetryC2DMessage, exports.PrefsC2DMessage).annotations({
    identifier: `${exports.NAMESPACE}.C2DMessage`,
});
exports.DeviceToCloud = common_1.Payload.create(2, hydrotap_bridge_1.HydroTapBridge, exports.D2CMessage, {
    title: `${hydrotap_bridge_1.HydroTapBridge.label} — Device to Cloud Protocol`,
}).annotations({
    identifier: `${exports.NAMESPACE}.DeviceToCloud`,
    title: `${hydrotap_bridge_1.HydroTapBridge.label} — Device to Cloud Protocol`,
});
exports.CloudToDevice = common_1.Payload.create(2, hydrotap_bridge_1.HydroTapBridge, exports.C2DMessage, {
    title: `${hydrotap_bridge_1.HydroTapBridge.label} — Cloud to Device Protocol`,
}).annotations({
    identifier: `${exports.NAMESPACE}.CloudToDevice`,
    title: `${hydrotap_bridge_1.HydroTapBridge.label} — Cloud to Device Protocol`,
});
//# sourceMappingURL=hydrotap-bridge.js.map